import { gql } from "graphql-request";

const RIDE_CREDIT_QUERY = gql`
  query RideCredit($attraction: String!, $user: String!) {
    rideCreditCount(where: { Attraction: $attraction, User: $user })
  }
`;

export default RIDE_CREDIT_QUERY;
